<template>
    <div>
        <!-- <div v-if="authUserPermission['characteristic-item-name-view']"> -->
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-1">
                    <div class="card-header mt--4 mb--4">
                        <div class="row">
                            <div class="col">
                                <h3 class="mb-0">{{ tt('material_profiling') }}</h3>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <input type="text" class="form-control form-control-sm text-center border-radius-20" v-model="valImport.search" v-on:keyup="filterMatProfiling"  placeholder="Search Description"/>
                                    <!-- v-on:keyup="filter" -->
                                </div>
                            </div>
                            <div class="col text-right">
                                <base-button class="btn-dark" style="margin-top:1px" size="sm" type="default" @click="importModal" >
                                    <span>{{ tt('import') }}</span>
                                </base-button>
                                <router-link :to="{ path: '/general_layout/workbench', query: { company: 'KAI', type: 'search-material' } }" class="btn btn-sm btn-default" tag="button">{{ tt('to_workbench') }}</router-link>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table height="450px" class="table-responsive table-flush custom-row-height" header-row-class-name="thead-light" :data="valImport.data" v-if="!onLoad">
                             <!-- :row-class-name="dupSignRow" -->
                            <el-table-column :label="tt('material_number')" :prop="tt('material_number')" min-width="190px" sortable>
                                <template v-slot="{row}">
                                    <div class="small-font">{{row.material_number}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('description')" :prop="tt('source_description')" min-width="250px" sortable>
                                <template v-slot="{row}">
                                    <div class="small-font">{{row.description}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('noun_modifier')" :prop="tt('inc')" min-width="220px" sortable>
                                <template v-slot="{row}">
                                    <div class="small-font">{{row.inc_after_prompt_ai}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('profiling_overview')" :prop="tt('string_profiling_overview')" min-width="300px" sortable>
                                <template v-slot="{row}">
                                    <pre class="small-font wrap-pre">{{row.string_profiling_overview}}</pre>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('unspsc_code')" :prop="tt('unspsc_code')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    <div class="small-font">{{row.unspsc_code}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('unspsc_description')" :prop="tt('unspsc_title')" min-width="250px" sortable>
                                <template v-slot="{row}">
                                    <div class="small-font">{{row.unspsc_title}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('validity_score')" :prop="tt('validity_score')" min-width="170px" sortable>
                                <template v-slot="{row}">
                                    <div class="small-font text-center">{{row.validity_score}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('potential_duplicate')" min-width="250px" sortable>
                                <template v-slot="{row}">
                                    <div class="mb-2" v-if="row.most_similar">
                                        <strong class="mr-1">{{ row.most_similar.material_number }}</strong>  
                                        <span class="badge badge-danger">{{ row.most_similar.percent }}%</span>  
                                        <div class="text-muted small text-truncate" style="max-width: 250px;">{{ row.most_similar.description }}</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column :label="tt('reference')" :prop="tt('reference')" min-width="180px" sortable>
                                <template v-slot="{row}">
                                    <span v-for="(ref,i) in row.reference" :key="i">
                                        <a :href="ref" class="badge badge-primary" target="_blank" rel="noopener noreferrer">
                                            {{ getSplittedDomain(ref) }}
                                        </a>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                        <page-loading v-else/>
                    </div>
                   <div class="card-footer pt-4 pb-4">
                        <!-- <span class="float-left">
                            <base-pagination :page-count="valImport.last_page"
                                v-model="valImport.current_page"
                                @click.native="changePage(valImport.current_page)" size="sm"></base-pagination>
                        </span>
                        <span class="float-right">
                            {{ tt('page_info', {size: (valImport.current_page - 1) * valImport.per_page + valImport.data.length, total: valImport.total})}}
                        </span> -->
                    </div>
                </div>
            </div>
            <validation-observer v-slot="{invalid}">
                <modal :show.sync="modalImport.show" size="lg">
                    <template slot="header">
                        <h5 class="modal-title">{{ tt('import_material_profiling') }}</h5>
                    </template>
                    <div>
                        <label class="form-control-label">{{ tt('file') }}<span class="text-danger">*</span></label>
                        <file-input @change="changeImport" ref="fileImportMaterialProfiling"></file-input>
                    </div>
                    <template slot="footer">
                        <base-button type="primary" v-on:click="importFile" :disabled="modalImport.onLoad || invalid || !modalImport.file">
                            <span v-if="modalImport.onLoad"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                            <span v-else>
                                <span>{{ tt('import') }}</span>
                            </span>
                        </base-button>
                    </template>
                </modal>
            </validation-observer>
        <!-- </div>
        <noaccess v-else /> -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Api from '@/helpers/api';
import importReport from '@/services/report/import.service';
// import { dummyImportMaterial } from '@/util/dummyImportMaterial.js'


export default {
    // watch: {
        
    // },
    data() {
        return {
            onLoad: false,
            onLoadCharValue: false,
            // valImport: dummyImportMaterial,
            valImport: {
                search: "",
                current_page: 0,
				from: 0,
				last_page: 0,
				per_page: 0,
				to: 0,
				total: 0,
				data: [],
            },
            valImportStatic: {
                data: [],
            },
            modalImport: {
                show: false,
                file: '',
                onLoad: false,
            }
        }
    },
    computed: {
        ...mapState({
            authUserPermission: state => state.auth.userPermission
        }),
    },
    // mounted() {
    //     console.log('value dummyImportMaterial', dummyImportMaterial)
    // },
    methods: {
        changeImport(files) {
            this.modalImport.file = files[0]
        },
        importModal() {
            this.modalImport.show = true;
            this.modalImport.onLoad = false;
        },
        importFile() {
            let context = this;
            let formData = new FormData();
            this.modalImport.onLoad = true;

            formData.append('excel', this.modalImport.file);
            Api(context, importReport.import_material_profiling(formData)).onSuccess(function(response) {
                // console.log("success",response.data.data)
                context.valImport.data = response.data.data;
                context.valImportStatic.data = response.data.data;
                context.$notify({
                    message: response.data.message,
                    type: "success",
                    verticalAlign: "bottom",
                    horizontalAlign: "left"
                });
            }).onError(function(error) {
                context.valImport.data = [];
                context.valImportStatic.data = [];
                context.$notify({
                    message: error.message ?? 'Error',                  
                    type: 'red'
                });
            }).onFinish(function() {
                // console.log("masuk finish")
                context.modalImport.show = false;
                context.modalImport.onLoad = false;
                context.$refs.fileImportMaterialProfiling.value = ""
            }).call();
        },
        changePage(page) {
            console.log(page)
            // let context = this;
            // context.onLoad.table = true;
            // context.onLoad.detail = true;
            // clearTimeout(this.loadTimeout);
            // this.loadTimeout = setTimeout(() => {
            //     this.get();
            // }, 100);
        },
        changePageCharValue(page) {
            console.log(page)
            // let context = this;
            // context.onLoadCharValue = true;

            // clearTimeout(this.loadTimeout);
            // this.loadTimeout = setTimeout(() => {
            //     this.getCharValue()
            // }, 100);
        },
        getSplittedDomain(val){
            const domain = val.match(/^https?:\/\/([^\/.]+(?:\.[^\/.]+)+)/i );
            return domain ? domain[1] : val;
        },
        getDescInc(val){
            if (val && val.includes(' - ')) {
                return val.split(" - ")[1].trim();
            }
            return val
        },
        dupSignRow({row, rowIndex}) {
            return (row.percent_similarity == 100) ? 'warning-row' : '';
        },
        filterMatProfiling() {
            if (this.valImport.search.length > 2) {
                this.valImport.data = this.valImportStatic.data.filter(i => {
                    const search = this.valImport.search.toLowerCase();
                    return (
                        i.description.toLowerCase().includes(search) ||
                        i.material_number.toLowerCase().includes(search)
                    );
                });
            } else {
                this.valImport.data = this.valImportStatic.data;
            }
        }
    }
};
</script>
<style scope>

div.el-table tbody td,
div.el-table thead th {
    padding: 0rem;
}

.small-font {
    font-size: 11px;
    margin-top: 10px;
    margin-bottom: 10px;
}

.form-control-sm {
    height: 25px
}

.el-table div .warning-row {
    background: #dcfafe !important;
}

.filter.mb--1:hover {
    color: #e9ecef;
    cursor: pointer;
}

.el-table__body tr.current-row>td {
    background-color: #ffe6bd !important;
}

.el-table th .cell {
    white-space: normal !important;
    word-break: break-word !important;
}

.wrap-pre {
    white-space: pre-wrap;
    word-break: break-word;
    word-wrap: break-word;
}

.custom-row-height .el-table__row {
  height: 70px !important;
}

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/*#cardCharacteristic.card .table td, #cardCharacteristic.card .table th, #cardCharacteristic.card .el-table td, #cardCharacteristic.card .el-table th{
        padding-left:0.1rem;
        padding-right:0.1rem;
    }*/
/* #tableChar.table thead th,
#tableChar.el-table thead th {
    letter-spacing: 0px;
    font-size: 0.59rem;
} */

/* #tableChar.table tbody td,
#tableChar.el-table tbody td {
    letter-spacing: 0px; */
    /*font-size: 0.69rem;*/
/* } */

</style>